import { default as activitiesyVvndrFrm4Meta } from "/root/vs2-front/pages/activities.vue?macro=true";
import { default as _91id_93jEsUhzC1YxMeta } from "/root/vs2-front/pages/chat/[id].vue?macro=true";
import { default as add_45friendspxvd91nbzfMeta } from "/root/vs2-front/pages/chat/add-friends.vue?macro=true";
import { default as createiv29L8whsnMeta } from "/root/vs2-front/pages/chat/create.vue?macro=true";
import { default as group_45members5PTj4Khc7mMeta } from "/root/vs2-front/pages/chat/group-members.vue?macro=true";
import { default as indexNMWIlJEp4OMeta } from "/root/vs2-front/pages/chat/index.vue?macro=true";
import { default as class_45membersNZiSOax539Meta } from "/root/vs2-front/pages/class/[id]/class-members.vue?macro=true";
import { default as indexJ57yAsm5z0Meta } from "/root/vs2-front/pages/class/[id]/index.vue?macro=true";
import { default as reserve_45class_45informationIY5EylLaGIMeta } from "/root/vs2-front/pages/class/[id]/reserve-class-information.vue?macro=true";
import { default as createDusGU6dIVFMeta } from "/root/vs2-front/pages/class/create.vue?macro=true";
import { default as gym_45listKiTiOZCEBvMeta } from "/root/vs2-front/pages/class/gym-list.vue?macro=true";
import { default as indexBkT0k6h0W5Meta } from "/root/vs2-front/pages/class/index.vue?macro=true";
import { default as infoajKmuaE8yBMeta } from "/root/vs2-front/pages/class/info.vue?macro=true";
import { default as listz3Hqot1gIJMeta } from "/root/vs2-front/pages/class/list.vue?macro=true";
import { default as reservedzjHMUcUnUhMeta } from "/root/vs2-front/pages/class/reserved.vue?macro=true";
import { default as academySLiQcoKBwXMeta } from "/root/vs2-front/pages/club/[id]/academy.vue?macro=true";
import { default as indexO9rdSshwmDMeta } from "/root/vs2-front/pages/club/[id]/index.vue?macro=true";
import { default as leagueslk8vklW4bTMeta } from "/root/vs2-front/pages/club/[id]/leagues.vue?macro=true";
import { default as reserveCjCwtoaulOMeta } from "/root/vs2-front/pages/club/[id]/reserve.vue?macro=true";
import { default as _91id_93XuOxKdPiSsMeta } from "/root/vs2-front/pages/club/[id].vue?macro=true";
import { default as indexybVg3gjoOJMeta } from "/root/vs2-front/pages/club/index.vue?macro=true";
import { default as add_45commentjuZrJ0WibZMeta } from "/root/vs2-front/pages/club/reserved/[id]/add-comment.vue?macro=true";
import { default as commentsQa5apw4xFJMeta } from "/root/vs2-front/pages/club/reserved/[id]/comments.vue?macro=true";
import { default as indexxBxwB02fm3Meta } from "/root/vs2-front/pages/club/reserved/[id]/index.vue?macro=true";
import { default as league_45detailsKgHoHkLHLhMeta } from "/root/vs2-front/pages/club/reserved/[id]/league-details.vue?macro=true";
import { default as league_45teamsHAQkUALb0PMeta } from "/root/vs2-front/pages/club/reserved/[id]/league-teams.vue?macro=true";
import { default as addFriendsmLigNTcBOnMeta } from "/root/vs2-front/pages/club/reserved/[id]/reserve-gym/addFriends.vue?macro=true";
import { default as index48OYUTtu2dMeta } from "/root/vs2-front/pages/club/reserved/[id]/reserve-gym/index.vue?macro=true";
import { default as matchInformationYvx7J0qCDYMeta } from "/root/vs2-front/pages/club/reserved/[id]/reserve-gym/matchInformation.vue?macro=true";
import { default as selectTeam4Lup885pUVMeta } from "/root/vs2-front/pages/club/reserved/[id]/reserve-gym/selectTeam.vue?macro=true";
import { default as selectTypefJTb2eAchMMeta } from "/root/vs2-front/pages/club/reserved/[id]/reserve-gym/selectType.vue?macro=true";
import { default as indexRshgbQu0OsMeta } from "/root/vs2-front/pages/club/reserved/index.vue?macro=true";
import { default as indexEK5WK0zF8kMeta } from "/root/vs2-front/pages/competitions/index.vue?macro=true";
import { default as indexysLwDy4sFAMeta } from "/root/vs2-front/pages/index.vue?macro=true";
import { default as indexLoOP9P5XhKMeta } from "/root/vs2-front/pages/leagues/[id]/index.vue?macro=true";
import { default as createJ8c8CWH4k0Meta } from "/root/vs2-front/pages/leagues/create.vue?macro=true";
import { default as indexAxPUA2M9mAMeta } from "/root/vs2-front/pages/leagues/index.vue?macro=true";
import { default as _91id_93wlRgFNCXlmMeta } from "/root/vs2-front/pages/lig/[id].vue?macro=true";
import { default as add_45friendNMLWrUDfBBMeta } from "/root/vs2-front/pages/lig/add-friend.vue?macro=true";
import { default as checkoutzF7yIRsOlaMeta } from "/root/vs2-front/pages/lig/checkout.vue?macro=true";
import { default as createX0hkCgcMb0Meta } from "/root/vs2-front/pages/lig/create.vue?macro=true";
import { default as indexe57DKKPFaCMeta } from "/root/vs2-front/pages/lig/index.vue?macro=true";
import { default as listAhOfLj2FSrMeta } from "/root/vs2-front/pages/lig/list.vue?macro=true";
import { default as select_45gymzihzmGSYG0Meta } from "/root/vs2-front/pages/lig/select-gym.vue?macro=true";
import { default as select_45teamlbDGHwOgE7Meta } from "/root/vs2-front/pages/lig/select-team.vue?macro=true";
import { default as indexqgF8u84kqEMeta } from "/root/vs2-front/pages/login/index.vue?macro=true";
import { default as otpqsoKZjCok3Meta } from "/root/vs2-front/pages/login/otp.vue?macro=true";
import { default as _91id_933A9cEhyLagMeta } from "/root/vs2-front/pages/match/[id].vue?macro=true";
import { default as indexZgFtZfAsFeMeta } from "/root/vs2-front/pages/match/index.vue?macro=true";
import { default as requestSCLatJlhAjMeta } from "/root/vs2-front/pages/match/request.vue?macro=true";
import { default as resultqbCfz2dnRUMeta } from "/root/vs2-front/pages/match/result.vue?macro=true";
import { default as _91id_93_46edit4OCjuxCoB5Meta } from "/root/vs2-front/pages/matches/[id].edit.vue?macro=true";
import { default as editGDUWG3DtciMeta } from "/root/vs2-front/pages/matches/[id]/edit.vue?macro=true";
import { default as indexrWNYjeuEnFMeta } from "/root/vs2-front/pages/matches/[id]/index.vue?macro=true";
import { default as _91id_93kmVXHiVB1LMeta } from "/root/vs2-front/pages/matches/[id].vue?macro=true";
import { default as createQYnHpw18dPMeta } from "/root/vs2-front/pages/matches/create.vue?macro=true";
import { default as indexBjnwvELKUiMeta } from "/root/vs2-front/pages/matches/index.vue?macro=true";
import { default as _91code_931GAl6CCotiMeta } from "/root/vs2-front/pages/matches/invite/[code].vue?macro=true";
import { default as _91id_93nQ6ebU1dEMMeta } from "/root/vs2-front/pages/notifications/[id].vue?macro=true";
import { default as indexod8thSnlhuMeta } from "/root/vs2-front/pages/notifications/index.vue?macro=true";
import { default as _91id_93OMuxIQgDKlMeta } from "/root/vs2-front/pages/profile/[id].vue?macro=true";
import { default as coach_45authenticationh9W0XJ0HdzMeta } from "/root/vs2-front/pages/profile/coach-authentication.vue?macro=true";
import { default as followersFhJ9Y1mOw3Meta } from "/root/vs2-front/pages/profile/followers.vue?macro=true";
import { default as index3o3lx0WGv0Meta } from "/root/vs2-front/pages/profile/index.vue?macro=true";
import { default as infovIkpEJAPpuMeta } from "/root/vs2-front/pages/profile/info.vue?macro=true";
import { default as matchs7RrWCDWPSsMeta } from "/root/vs2-front/pages/profile/matchs.vue?macro=true";
import { default as new_45passwordcunqniH4uQMeta } from "/root/vs2-front/pages/profile/new-password.vue?macro=true";
import { default as otpsf3YLlpZ3SMeta } from "/root/vs2-front/pages/profile/otp.vue?macro=true";
import { default as rankingKoADZ1tQmoMeta } from "/root/vs2-front/pages/profile/ranking.vue?macro=true";
import { default as skillsFEEBwUeH1eMeta } from "/root/vs2-front/pages/profile/skills.vue?macro=true";
import { default as depositY7ZPuydTC1Meta } from "/root/vs2-front/pages/profile/wallet/deposit.vue?macro=true";
import { default as indexik2TnvIXu8Meta } from "/root/vs2-front/pages/profile/wallet/index.vue?macro=true";
import { default as withdrawX1jLysh6sdMeta } from "/root/vs2-front/pages/profile/wallet/withdraw.vue?macro=true";
import { default as walletafV89IfAjnMeta } from "/root/vs2-front/pages/profile/wallet.vue?macro=true";
import { default as ratingTmxdrzT8F1Meta } from "/root/vs2-front/pages/rating.vue?macro=true";
import { default as completeh7dXUb6s2NMeta } from "/root/vs2-front/pages/register/complete.vue?macro=true";
import { default as indexLz1Rr5H8TzMeta } from "/root/vs2-front/pages/register/index.vue?macro=true";
import { default as levelingcyExNlApdrMeta } from "/root/vs2-front/pages/register/leveling.vue?macro=true";
import { default as otp89f6xjVS93Meta } from "/root/vs2-front/pages/register/otp.vue?macro=true";
import { default as select_45sportMWrm2QxqoTMeta } from "/root/vs2-front/pages/register/select-sport.vue?macro=true";
import { default as reset_45passwordak3QJVDDocMeta } from "/root/vs2-front/pages/reset-password.vue?macro=true";
import { default as addSd8eYRKz0dMeta } from "/root/vs2-front/pages/socials/[id]/comments/add.vue?macro=true";
import { default as indexLkkzf6y7cnMeta } from "/root/vs2-front/pages/socials/[id]/comments/index.vue?macro=true";
import { default as add_45post7FjyDugxkBMeta } from "/root/vs2-front/pages/socials/add-post.vue?macro=true";
import { default as indexNoY20nfyCDMeta } from "/root/vs2-front/pages/socials/index.vue?macro=true";
import { default as profilesPcInJaiiCyMeta } from "/root/vs2-front/pages/socials/profiles.vue?macro=true";
import { default as indexagMW7UqSw3Meta } from "/root/vs2-front/pages/tournaments/[id]/index.vue?macro=true";
import { default as indexlRaraLaU8yMeta } from "/root/vs2-front/pages/tournaments/index.vue?macro=true";
export default [
  {
    name: activitiesyVvndrFrm4Meta?.name ?? "activities",
    path: activitiesyVvndrFrm4Meta?.path ?? "/activities",
    meta: activitiesyVvndrFrm4Meta || {},
    alias: activitiesyVvndrFrm4Meta?.alias || [],
    redirect: activitiesyVvndrFrm4Meta?.redirect,
    component: () => import("/root/vs2-front/pages/activities.vue").then(m => m.default || m)
  },
  {
    name: _91id_93jEsUhzC1YxMeta?.name ?? "chat-id",
    path: _91id_93jEsUhzC1YxMeta?.path ?? "/chat/:id()",
    meta: _91id_93jEsUhzC1YxMeta || {},
    alias: _91id_93jEsUhzC1YxMeta?.alias || [],
    redirect: _91id_93jEsUhzC1YxMeta?.redirect,
    component: () => import("/root/vs2-front/pages/chat/[id].vue").then(m => m.default || m)
  },
  {
    name: add_45friendspxvd91nbzfMeta?.name ?? "chat-add-friends",
    path: add_45friendspxvd91nbzfMeta?.path ?? "/chat/add-friends",
    meta: add_45friendspxvd91nbzfMeta || {},
    alias: add_45friendspxvd91nbzfMeta?.alias || [],
    redirect: add_45friendspxvd91nbzfMeta?.redirect,
    component: () => import("/root/vs2-front/pages/chat/add-friends.vue").then(m => m.default || m)
  },
  {
    name: createiv29L8whsnMeta?.name ?? "chat-create",
    path: createiv29L8whsnMeta?.path ?? "/chat/create",
    meta: createiv29L8whsnMeta || {},
    alias: createiv29L8whsnMeta?.alias || [],
    redirect: createiv29L8whsnMeta?.redirect,
    component: () => import("/root/vs2-front/pages/chat/create.vue").then(m => m.default || m)
  },
  {
    name: group_45members5PTj4Khc7mMeta?.name ?? "chat-group-members",
    path: group_45members5PTj4Khc7mMeta?.path ?? "/chat/group-members",
    meta: group_45members5PTj4Khc7mMeta || {},
    alias: group_45members5PTj4Khc7mMeta?.alias || [],
    redirect: group_45members5PTj4Khc7mMeta?.redirect,
    component: () => import("/root/vs2-front/pages/chat/group-members.vue").then(m => m.default || m)
  },
  {
    name: indexNMWIlJEp4OMeta?.name ?? "chat",
    path: indexNMWIlJEp4OMeta?.path ?? "/chat",
    meta: indexNMWIlJEp4OMeta || {},
    alias: indexNMWIlJEp4OMeta?.alias || [],
    redirect: indexNMWIlJEp4OMeta?.redirect,
    component: () => import("/root/vs2-front/pages/chat/index.vue").then(m => m.default || m)
  },
  {
    name: class_45membersNZiSOax539Meta?.name ?? "class-id-class-members",
    path: class_45membersNZiSOax539Meta?.path ?? "/class/:id()/class-members",
    meta: class_45membersNZiSOax539Meta || {},
    alias: class_45membersNZiSOax539Meta?.alias || [],
    redirect: class_45membersNZiSOax539Meta?.redirect,
    component: () => import("/root/vs2-front/pages/class/[id]/class-members.vue").then(m => m.default || m)
  },
  {
    name: indexJ57yAsm5z0Meta?.name ?? "class-id",
    path: indexJ57yAsm5z0Meta?.path ?? "/class/:id()",
    meta: indexJ57yAsm5z0Meta || {},
    alias: indexJ57yAsm5z0Meta?.alias || [],
    redirect: indexJ57yAsm5z0Meta?.redirect,
    component: () => import("/root/vs2-front/pages/class/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: reserve_45class_45informationIY5EylLaGIMeta?.name ?? "class-id-reserve-class-information",
    path: reserve_45class_45informationIY5EylLaGIMeta?.path ?? "/class/:id()/reserve-class-information",
    meta: reserve_45class_45informationIY5EylLaGIMeta || {},
    alias: reserve_45class_45informationIY5EylLaGIMeta?.alias || [],
    redirect: reserve_45class_45informationIY5EylLaGIMeta?.redirect,
    component: () => import("/root/vs2-front/pages/class/[id]/reserve-class-information.vue").then(m => m.default || m)
  },
  {
    name: createDusGU6dIVFMeta?.name ?? "class-create",
    path: createDusGU6dIVFMeta?.path ?? "/class/create",
    meta: createDusGU6dIVFMeta || {},
    alias: createDusGU6dIVFMeta?.alias || [],
    redirect: createDusGU6dIVFMeta?.redirect,
    component: () => import("/root/vs2-front/pages/class/create.vue").then(m => m.default || m)
  },
  {
    name: gym_45listKiTiOZCEBvMeta?.name ?? "class-gym-list",
    path: gym_45listKiTiOZCEBvMeta?.path ?? "/class/gym-list",
    meta: gym_45listKiTiOZCEBvMeta || {},
    alias: gym_45listKiTiOZCEBvMeta?.alias || [],
    redirect: gym_45listKiTiOZCEBvMeta?.redirect,
    component: () => import("/root/vs2-front/pages/class/gym-list.vue").then(m => m.default || m)
  },
  {
    name: indexBkT0k6h0W5Meta?.name ?? "class",
    path: indexBkT0k6h0W5Meta?.path ?? "/class",
    meta: indexBkT0k6h0W5Meta || {},
    alias: indexBkT0k6h0W5Meta?.alias || [],
    redirect: indexBkT0k6h0W5Meta?.redirect,
    component: () => import("/root/vs2-front/pages/class/index.vue").then(m => m.default || m)
  },
  {
    name: infoajKmuaE8yBMeta?.name ?? "class-info",
    path: infoajKmuaE8yBMeta?.path ?? "/class/info",
    meta: infoajKmuaE8yBMeta || {},
    alias: infoajKmuaE8yBMeta?.alias || [],
    redirect: infoajKmuaE8yBMeta?.redirect,
    component: () => import("/root/vs2-front/pages/class/info.vue").then(m => m.default || m)
  },
  {
    name: listz3Hqot1gIJMeta?.name ?? "class-list",
    path: listz3Hqot1gIJMeta?.path ?? "/class/list",
    meta: listz3Hqot1gIJMeta || {},
    alias: listz3Hqot1gIJMeta?.alias || [],
    redirect: listz3Hqot1gIJMeta?.redirect,
    component: () => import("/root/vs2-front/pages/class/list.vue").then(m => m.default || m)
  },
  {
    name: reservedzjHMUcUnUhMeta?.name ?? "class-reserved",
    path: reservedzjHMUcUnUhMeta?.path ?? "/class/reserved",
    meta: reservedzjHMUcUnUhMeta || {},
    alias: reservedzjHMUcUnUhMeta?.alias || [],
    redirect: reservedzjHMUcUnUhMeta?.redirect,
    component: () => import("/root/vs2-front/pages/class/reserved.vue").then(m => m.default || m)
  },
  {
    name: _91id_93XuOxKdPiSsMeta?.name ?? undefined,
    path: _91id_93XuOxKdPiSsMeta?.path ?? "/club/:id()",
    meta: _91id_93XuOxKdPiSsMeta || {},
    alias: _91id_93XuOxKdPiSsMeta?.alias || [],
    redirect: _91id_93XuOxKdPiSsMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/[id].vue").then(m => m.default || m),
    children: [
  {
    name: academySLiQcoKBwXMeta?.name ?? "club-id-academy",
    path: academySLiQcoKBwXMeta?.path ?? "academy",
    meta: academySLiQcoKBwXMeta || {},
    alias: academySLiQcoKBwXMeta?.alias || [],
    redirect: academySLiQcoKBwXMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/[id]/academy.vue").then(m => m.default || m)
  },
  {
    name: indexO9rdSshwmDMeta?.name ?? "club-id",
    path: indexO9rdSshwmDMeta?.path ?? "",
    meta: indexO9rdSshwmDMeta || {},
    alias: indexO9rdSshwmDMeta?.alias || [],
    redirect: indexO9rdSshwmDMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: leagueslk8vklW4bTMeta?.name ?? "club-id-leagues",
    path: leagueslk8vklW4bTMeta?.path ?? "leagues",
    meta: leagueslk8vklW4bTMeta || {},
    alias: leagueslk8vklW4bTMeta?.alias || [],
    redirect: leagueslk8vklW4bTMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/[id]/leagues.vue").then(m => m.default || m)
  },
  {
    name: reserveCjCwtoaulOMeta?.name ?? "club-id-reserve",
    path: reserveCjCwtoaulOMeta?.path ?? "reserve",
    meta: reserveCjCwtoaulOMeta || {},
    alias: reserveCjCwtoaulOMeta?.alias || [],
    redirect: reserveCjCwtoaulOMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/[id]/reserve.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexybVg3gjoOJMeta?.name ?? "club",
    path: indexybVg3gjoOJMeta?.path ?? "/club",
    meta: indexybVg3gjoOJMeta || {},
    alias: indexybVg3gjoOJMeta?.alias || [],
    redirect: indexybVg3gjoOJMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/index.vue").then(m => m.default || m)
  },
  {
    name: add_45commentjuZrJ0WibZMeta?.name ?? "club-reserved-id-add-comment",
    path: add_45commentjuZrJ0WibZMeta?.path ?? "/club/reserved/:id()/add-comment",
    meta: add_45commentjuZrJ0WibZMeta || {},
    alias: add_45commentjuZrJ0WibZMeta?.alias || [],
    redirect: add_45commentjuZrJ0WibZMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/reserved/[id]/add-comment.vue").then(m => m.default || m)
  },
  {
    name: commentsQa5apw4xFJMeta?.name ?? "club-reserved-id-comments",
    path: commentsQa5apw4xFJMeta?.path ?? "/club/reserved/:id()/comments",
    meta: commentsQa5apw4xFJMeta || {},
    alias: commentsQa5apw4xFJMeta?.alias || [],
    redirect: commentsQa5apw4xFJMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/reserved/[id]/comments.vue").then(m => m.default || m)
  },
  {
    name: indexxBxwB02fm3Meta?.name ?? "club-reserved-id",
    path: indexxBxwB02fm3Meta?.path ?? "/club/reserved/:id()",
    meta: indexxBxwB02fm3Meta || {},
    alias: indexxBxwB02fm3Meta?.alias || [],
    redirect: indexxBxwB02fm3Meta?.redirect,
    component: () => import("/root/vs2-front/pages/club/reserved/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: league_45detailsKgHoHkLHLhMeta?.name ?? "club-reserved-id-league-details",
    path: league_45detailsKgHoHkLHLhMeta?.path ?? "/club/reserved/:id()/league-details",
    meta: league_45detailsKgHoHkLHLhMeta || {},
    alias: league_45detailsKgHoHkLHLhMeta?.alias || [],
    redirect: league_45detailsKgHoHkLHLhMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/reserved/[id]/league-details.vue").then(m => m.default || m)
  },
  {
    name: league_45teamsHAQkUALb0PMeta?.name ?? "club-reserved-id-league-teams",
    path: league_45teamsHAQkUALb0PMeta?.path ?? "/club/reserved/:id()/league-teams",
    meta: league_45teamsHAQkUALb0PMeta || {},
    alias: league_45teamsHAQkUALb0PMeta?.alias || [],
    redirect: league_45teamsHAQkUALb0PMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/reserved/[id]/league-teams.vue").then(m => m.default || m)
  },
  {
    name: addFriendsmLigNTcBOnMeta?.name ?? "club-reserved-id-reserve-gym-addFriends",
    path: addFriendsmLigNTcBOnMeta?.path ?? "/club/reserved/:id()/reserve-gym/addFriends",
    meta: addFriendsmLigNTcBOnMeta || {},
    alias: addFriendsmLigNTcBOnMeta?.alias || [],
    redirect: addFriendsmLigNTcBOnMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/reserved/[id]/reserve-gym/addFriends.vue").then(m => m.default || m)
  },
  {
    name: index48OYUTtu2dMeta?.name ?? "club-reserved-id-reserve-gym",
    path: index48OYUTtu2dMeta?.path ?? "/club/reserved/:id()/reserve-gym",
    meta: index48OYUTtu2dMeta || {},
    alias: index48OYUTtu2dMeta?.alias || [],
    redirect: index48OYUTtu2dMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/reserved/[id]/reserve-gym/index.vue").then(m => m.default || m)
  },
  {
    name: matchInformationYvx7J0qCDYMeta?.name ?? "club-reserved-id-reserve-gym-matchInformation",
    path: matchInformationYvx7J0qCDYMeta?.path ?? "/club/reserved/:id()/reserve-gym/matchInformation",
    meta: matchInformationYvx7J0qCDYMeta || {},
    alias: matchInformationYvx7J0qCDYMeta?.alias || [],
    redirect: matchInformationYvx7J0qCDYMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/reserved/[id]/reserve-gym/matchInformation.vue").then(m => m.default || m)
  },
  {
    name: selectTeam4Lup885pUVMeta?.name ?? "club-reserved-id-reserve-gym-selectTeam",
    path: selectTeam4Lup885pUVMeta?.path ?? "/club/reserved/:id()/reserve-gym/selectTeam",
    meta: selectTeam4Lup885pUVMeta || {},
    alias: selectTeam4Lup885pUVMeta?.alias || [],
    redirect: selectTeam4Lup885pUVMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/reserved/[id]/reserve-gym/selectTeam.vue").then(m => m.default || m)
  },
  {
    name: selectTypefJTb2eAchMMeta?.name ?? "club-reserved-id-reserve-gym-selectType",
    path: selectTypefJTb2eAchMMeta?.path ?? "/club/reserved/:id()/reserve-gym/selectType",
    meta: selectTypefJTb2eAchMMeta || {},
    alias: selectTypefJTb2eAchMMeta?.alias || [],
    redirect: selectTypefJTb2eAchMMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/reserved/[id]/reserve-gym/selectType.vue").then(m => m.default || m)
  },
  {
    name: indexRshgbQu0OsMeta?.name ?? "club-reserved",
    path: indexRshgbQu0OsMeta?.path ?? "/club/reserved",
    meta: indexRshgbQu0OsMeta || {},
    alias: indexRshgbQu0OsMeta?.alias || [],
    redirect: indexRshgbQu0OsMeta?.redirect,
    component: () => import("/root/vs2-front/pages/club/reserved/index.vue").then(m => m.default || m)
  },
  {
    name: indexEK5WK0zF8kMeta?.name ?? "competitions",
    path: indexEK5WK0zF8kMeta?.path ?? "/competitions",
    meta: indexEK5WK0zF8kMeta || {},
    alias: indexEK5WK0zF8kMeta?.alias || [],
    redirect: indexEK5WK0zF8kMeta?.redirect,
    component: () => import("/root/vs2-front/pages/competitions/index.vue").then(m => m.default || m)
  },
  {
    name: indexysLwDy4sFAMeta?.name ?? "index",
    path: indexysLwDy4sFAMeta?.path ?? "/",
    meta: indexysLwDy4sFAMeta || {},
    alias: indexysLwDy4sFAMeta?.alias || [],
    redirect: indexysLwDy4sFAMeta?.redirect,
    component: () => import("/root/vs2-front/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexLoOP9P5XhKMeta?.name ?? "leagues-id",
    path: indexLoOP9P5XhKMeta?.path ?? "/leagues/:id()",
    meta: indexLoOP9P5XhKMeta || {},
    alias: indexLoOP9P5XhKMeta?.alias || [],
    redirect: indexLoOP9P5XhKMeta?.redirect,
    component: () => import("/root/vs2-front/pages/leagues/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: createJ8c8CWH4k0Meta?.name ?? "leagues-create",
    path: createJ8c8CWH4k0Meta?.path ?? "/leagues/create",
    meta: createJ8c8CWH4k0Meta || {},
    alias: createJ8c8CWH4k0Meta?.alias || [],
    redirect: createJ8c8CWH4k0Meta?.redirect,
    component: () => import("/root/vs2-front/pages/leagues/create.vue").then(m => m.default || m)
  },
  {
    name: indexAxPUA2M9mAMeta?.name ?? "leagues",
    path: indexAxPUA2M9mAMeta?.path ?? "/leagues",
    meta: indexAxPUA2M9mAMeta || {},
    alias: indexAxPUA2M9mAMeta?.alias || [],
    redirect: indexAxPUA2M9mAMeta?.redirect,
    component: () => import("/root/vs2-front/pages/leagues/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93wlRgFNCXlmMeta?.name ?? "lig-id",
    path: _91id_93wlRgFNCXlmMeta?.path ?? "/lig/:id()",
    meta: _91id_93wlRgFNCXlmMeta || {},
    alias: _91id_93wlRgFNCXlmMeta?.alias || [],
    redirect: _91id_93wlRgFNCXlmMeta?.redirect,
    component: () => import("/root/vs2-front/pages/lig/[id].vue").then(m => m.default || m)
  },
  {
    name: add_45friendNMLWrUDfBBMeta?.name ?? "lig-add-friend",
    path: add_45friendNMLWrUDfBBMeta?.path ?? "/lig/add-friend",
    meta: add_45friendNMLWrUDfBBMeta || {},
    alias: add_45friendNMLWrUDfBBMeta?.alias || [],
    redirect: add_45friendNMLWrUDfBBMeta?.redirect,
    component: () => import("/root/vs2-front/pages/lig/add-friend.vue").then(m => m.default || m)
  },
  {
    name: checkoutzF7yIRsOlaMeta?.name ?? "lig-checkout",
    path: checkoutzF7yIRsOlaMeta?.path ?? "/lig/checkout",
    meta: checkoutzF7yIRsOlaMeta || {},
    alias: checkoutzF7yIRsOlaMeta?.alias || [],
    redirect: checkoutzF7yIRsOlaMeta?.redirect,
    component: () => import("/root/vs2-front/pages/lig/checkout.vue").then(m => m.default || m)
  },
  {
    name: createX0hkCgcMb0Meta?.name ?? "lig-create",
    path: createX0hkCgcMb0Meta?.path ?? "/lig/create",
    meta: createX0hkCgcMb0Meta || {},
    alias: createX0hkCgcMb0Meta?.alias || [],
    redirect: createX0hkCgcMb0Meta?.redirect,
    component: () => import("/root/vs2-front/pages/lig/create.vue").then(m => m.default || m)
  },
  {
    name: indexe57DKKPFaCMeta?.name ?? "lig",
    path: indexe57DKKPFaCMeta?.path ?? "/lig",
    meta: indexe57DKKPFaCMeta || {},
    alias: indexe57DKKPFaCMeta?.alias || [],
    redirect: indexe57DKKPFaCMeta?.redirect,
    component: () => import("/root/vs2-front/pages/lig/index.vue").then(m => m.default || m)
  },
  {
    name: listAhOfLj2FSrMeta?.name ?? "lig-list",
    path: listAhOfLj2FSrMeta?.path ?? "/lig/list",
    meta: listAhOfLj2FSrMeta || {},
    alias: listAhOfLj2FSrMeta?.alias || [],
    redirect: listAhOfLj2FSrMeta?.redirect,
    component: () => import("/root/vs2-front/pages/lig/list.vue").then(m => m.default || m)
  },
  {
    name: select_45gymzihzmGSYG0Meta?.name ?? "lig-select-gym",
    path: select_45gymzihzmGSYG0Meta?.path ?? "/lig/select-gym",
    meta: select_45gymzihzmGSYG0Meta || {},
    alias: select_45gymzihzmGSYG0Meta?.alias || [],
    redirect: select_45gymzihzmGSYG0Meta?.redirect,
    component: () => import("/root/vs2-front/pages/lig/select-gym.vue").then(m => m.default || m)
  },
  {
    name: select_45teamlbDGHwOgE7Meta?.name ?? "lig-select-team",
    path: select_45teamlbDGHwOgE7Meta?.path ?? "/lig/select-team",
    meta: select_45teamlbDGHwOgE7Meta || {},
    alias: select_45teamlbDGHwOgE7Meta?.alias || [],
    redirect: select_45teamlbDGHwOgE7Meta?.redirect,
    component: () => import("/root/vs2-front/pages/lig/select-team.vue").then(m => m.default || m)
  },
  {
    name: indexqgF8u84kqEMeta?.name ?? "login",
    path: indexqgF8u84kqEMeta?.path ?? "/login",
    meta: indexqgF8u84kqEMeta || {},
    alias: indexqgF8u84kqEMeta?.alias || [],
    redirect: indexqgF8u84kqEMeta?.redirect,
    component: () => import("/root/vs2-front/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: otpqsoKZjCok3Meta?.name ?? "login-otp",
    path: otpqsoKZjCok3Meta?.path ?? "/login/otp",
    meta: otpqsoKZjCok3Meta || {},
    alias: otpqsoKZjCok3Meta?.alias || [],
    redirect: otpqsoKZjCok3Meta?.redirect,
    component: () => import("/root/vs2-front/pages/login/otp.vue").then(m => m.default || m)
  },
  {
    name: _91id_933A9cEhyLagMeta?.name ?? "match-id",
    path: _91id_933A9cEhyLagMeta?.path ?? "/match/:id()",
    meta: _91id_933A9cEhyLagMeta || {},
    alias: _91id_933A9cEhyLagMeta?.alias || [],
    redirect: _91id_933A9cEhyLagMeta?.redirect,
    component: () => import("/root/vs2-front/pages/match/[id].vue").then(m => m.default || m)
  },
  {
    name: indexZgFtZfAsFeMeta?.name ?? "match",
    path: indexZgFtZfAsFeMeta?.path ?? "/match",
    meta: indexZgFtZfAsFeMeta || {},
    alias: indexZgFtZfAsFeMeta?.alias || [],
    redirect: indexZgFtZfAsFeMeta?.redirect,
    component: () => import("/root/vs2-front/pages/match/index.vue").then(m => m.default || m)
  },
  {
    name: requestSCLatJlhAjMeta?.name ?? "match-request",
    path: requestSCLatJlhAjMeta?.path ?? "/match/request",
    meta: requestSCLatJlhAjMeta || {},
    alias: requestSCLatJlhAjMeta?.alias || [],
    redirect: requestSCLatJlhAjMeta?.redirect,
    component: () => import("/root/vs2-front/pages/match/request.vue").then(m => m.default || m)
  },
  {
    name: resultqbCfz2dnRUMeta?.name ?? "match-result",
    path: resultqbCfz2dnRUMeta?.path ?? "/match/result",
    meta: resultqbCfz2dnRUMeta || {},
    alias: resultqbCfz2dnRUMeta?.alias || [],
    redirect: resultqbCfz2dnRUMeta?.redirect,
    component: () => import("/root/vs2-front/pages/match/result.vue").then(m => m.default || m)
  },
  {
    name: _91id_93_46edit4OCjuxCoB5Meta?.name ?? "matches-id.edit",
    path: _91id_93_46edit4OCjuxCoB5Meta?.path ?? "/matches/:id().edit",
    meta: _91id_93_46edit4OCjuxCoB5Meta || {},
    alias: _91id_93_46edit4OCjuxCoB5Meta?.alias || [],
    redirect: _91id_93_46edit4OCjuxCoB5Meta?.redirect,
    component: () => import("/root/vs2-front/pages/matches/[id].edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93kmVXHiVB1LMeta?.name ?? undefined,
    path: _91id_93kmVXHiVB1LMeta?.path ?? "/matches/:id()",
    meta: _91id_93kmVXHiVB1LMeta || {},
    alias: _91id_93kmVXHiVB1LMeta?.alias || [],
    redirect: _91id_93kmVXHiVB1LMeta?.redirect,
    component: () => import("/root/vs2-front/pages/matches/[id].vue").then(m => m.default || m),
    children: [
  {
    name: editGDUWG3DtciMeta?.name ?? "matches-id-edit",
    path: editGDUWG3DtciMeta?.path ?? "edit",
    meta: editGDUWG3DtciMeta || {},
    alias: editGDUWG3DtciMeta?.alias || [],
    redirect: editGDUWG3DtciMeta?.redirect,
    component: () => import("/root/vs2-front/pages/matches/[id]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexrWNYjeuEnFMeta?.name ?? "matches-id",
    path: indexrWNYjeuEnFMeta?.path ?? "",
    meta: indexrWNYjeuEnFMeta || {},
    alias: indexrWNYjeuEnFMeta?.alias || [],
    redirect: indexrWNYjeuEnFMeta?.redirect,
    component: () => import("/root/vs2-front/pages/matches/[id]/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: createQYnHpw18dPMeta?.name ?? "matches-create",
    path: createQYnHpw18dPMeta?.path ?? "/matches/create",
    meta: createQYnHpw18dPMeta || {},
    alias: createQYnHpw18dPMeta?.alias || [],
    redirect: createQYnHpw18dPMeta?.redirect,
    component: () => import("/root/vs2-front/pages/matches/create.vue").then(m => m.default || m)
  },
  {
    name: indexBjnwvELKUiMeta?.name ?? "matches",
    path: indexBjnwvELKUiMeta?.path ?? "/matches",
    meta: indexBjnwvELKUiMeta || {},
    alias: indexBjnwvELKUiMeta?.alias || [],
    redirect: indexBjnwvELKUiMeta?.redirect,
    component: () => import("/root/vs2-front/pages/matches/index.vue").then(m => m.default || m)
  },
  {
    name: _91code_931GAl6CCotiMeta?.name ?? "matches-invite-code",
    path: _91code_931GAl6CCotiMeta?.path ?? "/matches/invite/:code()",
    meta: _91code_931GAl6CCotiMeta || {},
    alias: _91code_931GAl6CCotiMeta?.alias || [],
    redirect: _91code_931GAl6CCotiMeta?.redirect,
    component: () => import("/root/vs2-front/pages/matches/invite/[code].vue").then(m => m.default || m)
  },
  {
    name: _91id_93nQ6ebU1dEMMeta?.name ?? "notifications-id",
    path: _91id_93nQ6ebU1dEMMeta?.path ?? "/notifications/:id()",
    meta: _91id_93nQ6ebU1dEMMeta || {},
    alias: _91id_93nQ6ebU1dEMMeta?.alias || [],
    redirect: _91id_93nQ6ebU1dEMMeta?.redirect,
    component: () => import("/root/vs2-front/pages/notifications/[id].vue").then(m => m.default || m)
  },
  {
    name: indexod8thSnlhuMeta?.name ?? "notifications",
    path: indexod8thSnlhuMeta?.path ?? "/notifications",
    meta: indexod8thSnlhuMeta || {},
    alias: indexod8thSnlhuMeta?.alias || [],
    redirect: indexod8thSnlhuMeta?.redirect,
    component: () => import("/root/vs2-front/pages/notifications/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93OMuxIQgDKlMeta?.name ?? "profile-id",
    path: _91id_93OMuxIQgDKlMeta?.path ?? "/profile/:id()",
    meta: _91id_93OMuxIQgDKlMeta || {},
    alias: _91id_93OMuxIQgDKlMeta?.alias || [],
    redirect: _91id_93OMuxIQgDKlMeta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/[id].vue").then(m => m.default || m)
  },
  {
    name: coach_45authenticationh9W0XJ0HdzMeta?.name ?? "profile-coach-authentication",
    path: coach_45authenticationh9W0XJ0HdzMeta?.path ?? "/profile/coach-authentication",
    meta: coach_45authenticationh9W0XJ0HdzMeta || {},
    alias: coach_45authenticationh9W0XJ0HdzMeta?.alias || [],
    redirect: coach_45authenticationh9W0XJ0HdzMeta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/coach-authentication.vue").then(m => m.default || m)
  },
  {
    name: followersFhJ9Y1mOw3Meta?.name ?? "profile-followers",
    path: followersFhJ9Y1mOw3Meta?.path ?? "/profile/followers",
    meta: followersFhJ9Y1mOw3Meta || {},
    alias: followersFhJ9Y1mOw3Meta?.alias || [],
    redirect: followersFhJ9Y1mOw3Meta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/followers.vue").then(m => m.default || m)
  },
  {
    name: index3o3lx0WGv0Meta?.name ?? "profile",
    path: index3o3lx0WGv0Meta?.path ?? "/profile",
    meta: index3o3lx0WGv0Meta || {},
    alias: index3o3lx0WGv0Meta?.alias || [],
    redirect: index3o3lx0WGv0Meta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: infovIkpEJAPpuMeta?.name ?? "profile-info",
    path: infovIkpEJAPpuMeta?.path ?? "/profile/info",
    meta: infovIkpEJAPpuMeta || {},
    alias: infovIkpEJAPpuMeta?.alias || [],
    redirect: infovIkpEJAPpuMeta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/info.vue").then(m => m.default || m)
  },
  {
    name: matchs7RrWCDWPSsMeta?.name ?? "profile-matchs",
    path: matchs7RrWCDWPSsMeta?.path ?? "/profile/matchs",
    meta: matchs7RrWCDWPSsMeta || {},
    alias: matchs7RrWCDWPSsMeta?.alias || [],
    redirect: matchs7RrWCDWPSsMeta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/matchs.vue").then(m => m.default || m)
  },
  {
    name: new_45passwordcunqniH4uQMeta?.name ?? "profile-new-password",
    path: new_45passwordcunqniH4uQMeta?.path ?? "/profile/new-password",
    meta: new_45passwordcunqniH4uQMeta || {},
    alias: new_45passwordcunqniH4uQMeta?.alias || [],
    redirect: new_45passwordcunqniH4uQMeta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/new-password.vue").then(m => m.default || m)
  },
  {
    name: otpsf3YLlpZ3SMeta?.name ?? "profile-otp",
    path: otpsf3YLlpZ3SMeta?.path ?? "/profile/otp",
    meta: otpsf3YLlpZ3SMeta || {},
    alias: otpsf3YLlpZ3SMeta?.alias || [],
    redirect: otpsf3YLlpZ3SMeta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/otp.vue").then(m => m.default || m)
  },
  {
    name: rankingKoADZ1tQmoMeta?.name ?? "profile-ranking",
    path: rankingKoADZ1tQmoMeta?.path ?? "/profile/ranking",
    meta: rankingKoADZ1tQmoMeta || {},
    alias: rankingKoADZ1tQmoMeta?.alias || [],
    redirect: rankingKoADZ1tQmoMeta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/ranking.vue").then(m => m.default || m)
  },
  {
    name: skillsFEEBwUeH1eMeta?.name ?? "profile-skills",
    path: skillsFEEBwUeH1eMeta?.path ?? "/profile/skills",
    meta: skillsFEEBwUeH1eMeta || {},
    alias: skillsFEEBwUeH1eMeta?.alias || [],
    redirect: skillsFEEBwUeH1eMeta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/skills.vue").then(m => m.default || m)
  },
  {
    name: walletafV89IfAjnMeta?.name ?? undefined,
    path: walletafV89IfAjnMeta?.path ?? "/profile/wallet",
    meta: walletafV89IfAjnMeta || {},
    alias: walletafV89IfAjnMeta?.alias || [],
    redirect: walletafV89IfAjnMeta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/wallet.vue").then(m => m.default || m),
    children: [
  {
    name: depositY7ZPuydTC1Meta?.name ?? "profile-wallet-deposit",
    path: depositY7ZPuydTC1Meta?.path ?? "deposit",
    meta: depositY7ZPuydTC1Meta || {},
    alias: depositY7ZPuydTC1Meta?.alias || [],
    redirect: depositY7ZPuydTC1Meta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/wallet/deposit.vue").then(m => m.default || m)
  },
  {
    name: indexik2TnvIXu8Meta?.name ?? "profile-wallet",
    path: indexik2TnvIXu8Meta?.path ?? "",
    meta: indexik2TnvIXu8Meta || {},
    alias: indexik2TnvIXu8Meta?.alias || [],
    redirect: indexik2TnvIXu8Meta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: withdrawX1jLysh6sdMeta?.name ?? "profile-wallet-withdraw",
    path: withdrawX1jLysh6sdMeta?.path ?? "withdraw",
    meta: withdrawX1jLysh6sdMeta || {},
    alias: withdrawX1jLysh6sdMeta?.alias || [],
    redirect: withdrawX1jLysh6sdMeta?.redirect,
    component: () => import("/root/vs2-front/pages/profile/wallet/withdraw.vue").then(m => m.default || m)
  }
]
  },
  {
    name: ratingTmxdrzT8F1Meta?.name ?? "rating",
    path: ratingTmxdrzT8F1Meta?.path ?? "/rating",
    meta: ratingTmxdrzT8F1Meta || {},
    alias: ratingTmxdrzT8F1Meta?.alias || [],
    redirect: ratingTmxdrzT8F1Meta?.redirect,
    component: () => import("/root/vs2-front/pages/rating.vue").then(m => m.default || m)
  },
  {
    name: completeh7dXUb6s2NMeta?.name ?? "register-complete",
    path: completeh7dXUb6s2NMeta?.path ?? "/register/complete",
    meta: completeh7dXUb6s2NMeta || {},
    alias: completeh7dXUb6s2NMeta?.alias || [],
    redirect: completeh7dXUb6s2NMeta?.redirect,
    component: () => import("/root/vs2-front/pages/register/complete.vue").then(m => m.default || m)
  },
  {
    name: indexLz1Rr5H8TzMeta?.name ?? "register",
    path: indexLz1Rr5H8TzMeta?.path ?? "/register",
    meta: indexLz1Rr5H8TzMeta || {},
    alias: indexLz1Rr5H8TzMeta?.alias || [],
    redirect: indexLz1Rr5H8TzMeta?.redirect,
    component: () => import("/root/vs2-front/pages/register/index.vue").then(m => m.default || m)
  },
  {
    name: levelingcyExNlApdrMeta?.name ?? "register-leveling",
    path: levelingcyExNlApdrMeta?.path ?? "/register/leveling",
    meta: levelingcyExNlApdrMeta || {},
    alias: levelingcyExNlApdrMeta?.alias || [],
    redirect: levelingcyExNlApdrMeta?.redirect,
    component: () => import("/root/vs2-front/pages/register/leveling.vue").then(m => m.default || m)
  },
  {
    name: otp89f6xjVS93Meta?.name ?? "register-otp",
    path: otp89f6xjVS93Meta?.path ?? "/register/otp",
    meta: otp89f6xjVS93Meta || {},
    alias: otp89f6xjVS93Meta?.alias || [],
    redirect: otp89f6xjVS93Meta?.redirect,
    component: () => import("/root/vs2-front/pages/register/otp.vue").then(m => m.default || m)
  },
  {
    name: select_45sportMWrm2QxqoTMeta?.name ?? "register-select-sport",
    path: select_45sportMWrm2QxqoTMeta?.path ?? "/register/select-sport",
    meta: select_45sportMWrm2QxqoTMeta || {},
    alias: select_45sportMWrm2QxqoTMeta?.alias || [],
    redirect: select_45sportMWrm2QxqoTMeta?.redirect,
    component: () => import("/root/vs2-front/pages/register/select-sport.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordak3QJVDDocMeta?.name ?? "reset-password",
    path: reset_45passwordak3QJVDDocMeta?.path ?? "/reset-password",
    meta: reset_45passwordak3QJVDDocMeta || {},
    alias: reset_45passwordak3QJVDDocMeta?.alias || [],
    redirect: reset_45passwordak3QJVDDocMeta?.redirect,
    component: () => import("/root/vs2-front/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: addSd8eYRKz0dMeta?.name ?? "socials-id-comments-add",
    path: addSd8eYRKz0dMeta?.path ?? "/socials/:id()/comments/add",
    meta: addSd8eYRKz0dMeta || {},
    alias: addSd8eYRKz0dMeta?.alias || [],
    redirect: addSd8eYRKz0dMeta?.redirect,
    component: () => import("/root/vs2-front/pages/socials/[id]/comments/add.vue").then(m => m.default || m)
  },
  {
    name: indexLkkzf6y7cnMeta?.name ?? "socials-id-comments",
    path: indexLkkzf6y7cnMeta?.path ?? "/socials/:id()/comments",
    meta: indexLkkzf6y7cnMeta || {},
    alias: indexLkkzf6y7cnMeta?.alias || [],
    redirect: indexLkkzf6y7cnMeta?.redirect,
    component: () => import("/root/vs2-front/pages/socials/[id]/comments/index.vue").then(m => m.default || m)
  },
  {
    name: add_45post7FjyDugxkBMeta?.name ?? "socials-add-post",
    path: add_45post7FjyDugxkBMeta?.path ?? "/socials/add-post",
    meta: add_45post7FjyDugxkBMeta || {},
    alias: add_45post7FjyDugxkBMeta?.alias || [],
    redirect: add_45post7FjyDugxkBMeta?.redirect,
    component: () => import("/root/vs2-front/pages/socials/add-post.vue").then(m => m.default || m)
  },
  {
    name: indexNoY20nfyCDMeta?.name ?? "socials",
    path: indexNoY20nfyCDMeta?.path ?? "/socials",
    meta: indexNoY20nfyCDMeta || {},
    alias: indexNoY20nfyCDMeta?.alias || [],
    redirect: indexNoY20nfyCDMeta?.redirect,
    component: () => import("/root/vs2-front/pages/socials/index.vue").then(m => m.default || m)
  },
  {
    name: profilesPcInJaiiCyMeta?.name ?? "socials-profiles",
    path: profilesPcInJaiiCyMeta?.path ?? "/socials/profiles",
    meta: profilesPcInJaiiCyMeta || {},
    alias: profilesPcInJaiiCyMeta?.alias || [],
    redirect: profilesPcInJaiiCyMeta?.redirect,
    component: () => import("/root/vs2-front/pages/socials/profiles.vue").then(m => m.default || m)
  },
  {
    name: indexagMW7UqSw3Meta?.name ?? "tournaments-id",
    path: indexagMW7UqSw3Meta?.path ?? "/tournaments/:id()",
    meta: indexagMW7UqSw3Meta || {},
    alias: indexagMW7UqSw3Meta?.alias || [],
    redirect: indexagMW7UqSw3Meta?.redirect,
    component: () => import("/root/vs2-front/pages/tournaments/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexlRaraLaU8yMeta?.name ?? "tournaments",
    path: indexlRaraLaU8yMeta?.path ?? "/tournaments",
    meta: indexlRaraLaU8yMeta || {},
    alias: indexlRaraLaU8yMeta?.alias || [],
    redirect: indexlRaraLaU8yMeta?.redirect,
    component: () => import("/root/vs2-front/pages/tournaments/index.vue").then(m => m.default || m)
  }
]